export const DDialogGestureMode = wcardinal.ui.DDialogGestureMode;